import PropTypes from 'prop-types';

const displayName = 'SearchBox';
const propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
const defaultProps = {
  onChange: () => {},
};

export default {
  displayName,
  propTypes,
  defaultProps,
};
